<template>
  <div class="component-title">
    <span v-if="!$slots.title" class="title">{{title}}<span> {{describe}}</span></span>
    <slot v-if="$slots.title" name="title"></slot>
    <div class="buttons">
      <slot></slot>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  @import "card-header.theme";
  .component-title{
    height: $card-header-button-height;
    line-height:$card-header-button-height;
    .title{
      font-size:$card-header-title-font-size;
      font-weight:$card-header-title-font-weight;
      float:left;
      span {
        color:red;
        font-weight:700
      }
    }
    .buttons{
      float:right;
      > * {
        margin-left:$card-header-button-margin-left;
        display:inline-block;
      }
    }
  }
  .el-card__header{
    padding: #{$card-header-padding - 2 $card-header-padding};
  }
  .el-card__header + .el-card__body{
    height:calc(100% - #{2 * $card-header-padding - 2 + $card-header-button-height});
    box-sizing:border-box;
    overflow:auto;
  }
</style>

<!--☯js-->
<script>
  import * as eventJs from '../../../../../../src/base-components/card-header/event.js'
  const {event, life, watch} = eventJs.default ? eventJs.default : eventJs
  import * as modelJS from '../../../../../../src/base-components/card-header/model.js'
  const model = modelJS.default ? modelJS.default : modelJS
  import * as methodsJs from '../../../../../../src/base-components/card-header/methods.js'
  const methodsSource = methodsJs.default ? methodsJs.default : methodsJs
  import vmConfig from '../../../../core/vmConfigHandler.js'
  // 异步加载某些情况下会出问题，原因未知，所以暂时不采用异步加载
  // r => require.ensure([], () => r(require('%path')), 'c-base-card-header')
  export default {
    name: 'base-card-header', // o not use built-in or reserved HTML elements as component id:img, 意思是不能和html标签同名，那么加个下划线好了
    components: {
      /*import components file template:'base-card-header': require('%path').default,
       */
      /*start:import components file*/
/*end:import components file*/
    },
    ...vmConfig(model, life, event, watch, methodsSource)
  }
</script>